<!-- Initialization Loading State -->
<div class="init-loading-state" *ngIf="isInitializing">
  <div class="init-loading-content">
    <div class="init-loading-spinner"></div>
    <span>Loading Tickets...</span>
  </div>
</div>

<div class="ticket-workspace" *ngIf="!isInitializing">
  <!-- Content Header (queue view only — the detail view has its own header) -->
  <div class="content-header" *ngIf="!selectedIssueId">
    <div class="header-info">
      <i class="fa-solid fa-ticket"></i>
      <div class="header-text">
        <h1>Tickets</h1>
        <p>Track and resolve support tickets across all channels</p>
      </div>
    </div>
    <!-- Org context moved to the global header switcher -->
  </div>

  <!-- Queue or Detail -->
  <div class="workspace-body">
    <izzy-ticket-queue
      *ngIf="!selectedIssueId"
      [organizationId]="selectedOrg?.ID"
      [assigneeFilter]="assigneeFilter"
      (openTicket)="onOpenTicket($event)"
    ></izzy-ticket-queue>

    <izzy-ticket-detail
      *ngIf="selectedIssueId"
      [issueId]="selectedIssueId"
      (back)="onCloseTicket()"
    ></izzy-ticket-detail>
  </div>
</div>
